/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

console.log('Hello World from Webpacker')

require("@rails/ujs").start()
require("trix")
require("@rails/actiontext")

import $ from 'jquery'
import 'select2'
import 'select2/dist/css/select2.css'

function toggleRpps(has_rpps) {
  if (has_rpps) {
    $('#user_rpps_number').prop('required',true)
    $('#no_rpps').prop('required', false);
    $('#rpps').show()
    $('#no_rpps_declaration').hide()
  } else {
    $('#user_rpps_number').prop('required', false)
    $('#no_rpps').prop('required', true);
    $('#rpps').hide()
    $('#no_rpps_declaration').show()
  }
}

function toggleLoginButton() {
  const filled = !!$('#user_email').val() && !!$('#user_password').val();
  const classToAdd = filled ? 'btn-primary' : 'btn-secondary';
  const classToRemove = filled ? 'btn-secondary' : 'btn-primary';
  const loginButton = $('#user-login')[0];
  if (loginButton) {
    loginButton.classList.remove(classToRemove);
    loginButton.classList.add(classToAdd);
    $('#user-login').attr('disabled', !filled);
  }
}

function toggleNurse(isFrench) {
  $('option[value="nurse"]')[0].style.display = isFrench ? 'none' : 'initial';
}



$(document).ready(() => {
  // Mobile side nav toggle
  function openSideNav() {
    document.body.classList.add('side-nav-open');
    const btn = document.querySelector('.menu-toggle');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function closeSideNav() {
    document.body.classList.remove('side-nav-open');
    const btn = document.querySelector('.menu-toggle');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  $(document).on('click', '.menu-toggle, .content-menu-toggle', function() {
    if (document.body.classList.contains('side-nav-open')) {
      closeSideNav();
    } else {
      openSideNav();
    }
  });

  $(document).on('click', '#side-nav-overlay', function() {
    closeSideNav();
  });

  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') closeSideNav();
  });
  $('.select2').select2({width: '150px'});

  $('.language-select').on('change', function() {
    const newPath = (window.location.pathname.match(/^\/[^\/]*\//)) ?
      window.location.pathname.replace(/^\/[^\/]*\//, '')
      : ''
    const locale = $(this).val()
    const queryString = window.location.search; 
    window.location = window.location.origin + "/" + locale + "/" + newPath + queryString;
  })

  if (localStorage.getItem("country_code_vivacy") === null){
    $('#popup').css('display', 'flex');
  }

  $('.country-select-popup').on('change', function() {
    const country_code = $(this).val().toLowerCase();
    const languageSelect = $('.language-select-popup');
    const lowercaseOptions = languageSelect.find('option').map(function() {
      return $(this).val().toLowerCase();
    }).get();

    const index = lowercaseOptions.indexOf(country_code);
    if (index !== -1) {
      languageSelect.val(country_code);
      languageSelect.trigger('change');
    }
  });


  $('.country-select').on('change', function() {
    const country_code = $(this).val();    
    const newPath = (window.location.pathname.match(/^\/[^\/]*\//)) ?
    window.location.pathname.replace(/^\/[^\/]*\//, '')
    : ''
    localStorage.setItem("country_code_vivacy", country_code);
    const locale = $('.language-select').val()

    const queryString = window.location.search;
    const regex = new RegExp('([?&])country_code=([^&]*)');
    const newQueryString = queryString.replace(regex, function(match, p1, p2) {
        return p1 + 'country_code=' + country_code;
    });
    if (!newQueryString.includes('country_code=')) {
        newQueryString += (newQueryString ? '&' : '?') + 'country_code=' + country_code;
    }
    const newUrl = window.location.origin + '/' + locale + '/' + newPath + newQueryString;
    window.location = newUrl;
  });

    $('nav a').on('click', function(event) {
      var href = $(this).attr('href');
      if (!href || href.startsWith('#')) return;
      event.preventDefault();
      var separator = href.indexOf('?') !== -1 ? '&' : '?';
      var newHref = href + separator + 'country_code=' + localStorage.getItem("country_code_vivacy");
      window.history.replaceState({}, document.title, newHref);
      window.location.href = newHref;
  });

  function addCountryCodeToURL(href) {
    if (!href) return href;
    
    // Handle hash links - extract hash and add query before it
    var hashIndex = href.indexOf('#');
    var hash = '';
    var baseHref = href;
    
    if (hashIndex !== -1) {
      hash = href.substring(hashIndex);
      baseHref = href.substring(0, hashIndex);
    }
    
    // Check if country_code already exists in the URL
    var countryCode = localStorage.getItem("country_code_vivacy");
    if (baseHref.indexOf('country_code=') !== -1) {
      // Replace existing country_code
      var regex = /([?&])country_code=[^&]*/;
      baseHref = baseHref.replace(regex, '$1country_code=' + countryCode);
      var newHref = baseHref;
    } else {
      // Add country_code to base URL
      var separator = baseHref.indexOf('?') !== -1 ? '&' : '?';
      var newHref = baseHref + separator + 'country_code=' + countryCode;
    }
    
    // Re-append hash if it existed
    return newHref + hash;
  }

  $(document).on('click', 'a', function(event) {
    var href = $(this).attr('href');
    // If it's an internal link (not targeting a different window or a download), modify the URL
    if (href && !href.startsWith('#') && !href.startsWith('http') && !href.includes('.pdf') && !$(this).attr('target')) {
        event.preventDefault();
        
        // If href is just a hash (like #ticket), use current page URL as base
        if (href.startsWith('#')) {
          var currentPath = window.location.pathname;
          var currentSearch = window.location.search;
          var baseUrl = currentPath + currentSearch;
          var newHref = addCountryCodeToURL(baseUrl + href);
          window.location.href = newHref;
        } else {
          var newHref = addCountryCodeToURL(href);
          window.location.href = newHref;
        }
    }
  });

  $('.close-popup').on('click', function() {
    const newPath = (window.location.pathname.match(/^\/[^\/]*\//)) ?
        window.location.pathname.replace(/^\/[^\/]*\//, '') : '';
    const locale = $('.language-select-popup').val();
    const country_code = $('.country-select-popup').val();
    localStorage.setItem("country_code_vivacy", country_code);
    const queryString = window.location.search;
    let newQueryString = queryString;
    const regex = new RegExp('([?&])country_code=([^&]*)');
    if (queryString.match(regex)) {
        newQueryString = queryString.replace(regex, function(match, p1, p2) {
            return p1 + 'country_code=' + country_code;
        });
    } else {
        newQueryString += (newQueryString ? '&' : '?') + 'country_code=' + country_code;
    }
    const origin = window.location.origin;
    const newUrl = origin + '/' + locale + '/' + newPath + newQueryString;
    window.location.href = newUrl;
    $('.popup').hide();
  });

  $('#scans .report_issue').on('click', function(e) {
    $("#ticket_rfid_number").val($(e.target).attr('rfid_number'));
  });

  const placeholder = $('#ticket_image_label').text();
  $('#ticket_image').on( 'change', function(e) {
    const filename = e.target.files[0] ? e.target.files[0].name : placeholder;
    $('#ticket_image_label').text(filename);
    $('#ticket_image_preview').attr('src', e.target.files[0] ? URL.createObjectURL(e.target.files[0]) : '');
  });

  $('#user_country').on('change', function() {
    const isFrench = window.french_countries.split(',').includes($(this).val());
    toggleRpps(isFrench);
    toggleNurse(isFrench);
  });

  $('.buttons').on('click', 'a', function(e) {
    e.preventDefault();
    const country_code = localStorage.getItem("country_code_vivacy");
    const $link = $(this);
    const target = $link.attr('target');
    // Use attr('href') to get the exact href attribute value, which preserves the hash
    let href = $link.attr('href');
    
    if (!href) return;
    
    // Use URL API to properly handle the URL and preserve hash
    let url;
    try {
      // Resolve relative URLs to absolute
      url = new URL(href, window.location.origin);
    } catch (e) {
      // Fallback if URL parsing fails
      console.error('Error parsing URL:', e);
      return;
    }
    
    if (country_code) {
      // Add country_code to query string (URLSearchParams handles this properly)
      url.searchParams.set('country_code', country_code);
      // Hash is automatically preserved by the URL object
      const newUrl = url.toString();
      
      // Use window.open for target="_blank" links, otherwise use window.location
      if (target === '_blank') {
        window.open(newUrl, '_blank');
      } else {
        window.location = newUrl;
      }
    } else {
      // If no country_code, just follow the link normally
      const finalUrl = url.toString();
      if (target === '_blank') {
        window.open(finalUrl, '_blank');
      } else {
        window.location = finalUrl;
      }
    }
  });

  $(document).on('click', '.request-paper-toggle', function() {
    const targetId = $(this).data('target');
    const form = $('#' + targetId);
    if (form.length) {
      form.slideToggle();
    }
  });

  $('#user_country').trigger('change');

  function addCountryCodeToURLAndReload() {
    const country_code = localStorage.getItem("country_code_vivacy");
    if (country_code) {
        const urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.has('country_code')) {
            urlParams.set('country_code', country_code);
            window.location.search = urlParams.toString();
        }
    }
}

  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has('country_code')) {
      addCountryCodeToURLAndReload();
  }

  toggleLoginButton();
  $('#user_email').on('keyup', toggleLoginButton);
  $('#user_password').on('keyup', toggleLoginButton);

  // Products header scroll arrows
  function updateScrollArrows(context) {
    const root = context || document;
    const container = root.querySelector ? root.querySelector('#products-header') : document.querySelector('#products-header');
    if (!container) return;

    const leftArrow = root.querySelector ? root.querySelector('.scroll-left') : document.querySelector('.scroll-left');
    const rightArrow = root.querySelector ? root.querySelector('.scroll-right') : document.querySelector('.scroll-right');
    if (!leftArrow || !rightArrow) return;

    const scrollLeft = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;
    leftArrow.disabled = scrollLeft <= 0;
    rightArrow.disabled = scrollLeft >= maxScroll - 1; // Small tolerance for rounding
  }

  function scrollHeader(container, delta) {
    if (!container) return;
    const target = Math.max(0, Math.min(container.scrollLeft + delta, container.scrollWidth - container.clientWidth));
    container.scrollTo ? container.scrollTo({ left: target, behavior: 'smooth' }) : (container.scrollLeft = target);
  }

  function scrollToPrevBrand() {
    const container = document.getElementById('products-header');
    if (!container) return;
    const items = Array.from(container.querySelectorAll('.brand'));
    const leftEdge = container.scrollLeft;
    // Find the last item fully to the left of the viewport
    const prev = [...items].reverse().find((el) => el.offsetLeft + el.offsetWidth <= leftEdge - 1);
    if (prev) {
      const target = prev.offsetLeft - 16; // small padding
      container.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    } else {
      // fallback: page left by one viewport
      scrollHeader(container, -container.clientWidth + 60);
    }
    setTimeout(() => updateScrollArrows(document), 150);
  }

  function scrollToNextBrand() {
    const container = document.getElementById('products-header');
    if (!container) return;
    const items = Array.from(container.querySelectorAll('.brand'));
    const leftEdge = container.scrollLeft;
    const rightEdge = leftEdge + container.clientWidth;
    // Find first item that is at least partially beyond the right edge
    const next = items.find((el) => el.offsetLeft >= rightEdge - 1 || (el.offsetLeft + el.offsetWidth) > rightEdge + 1);
    if (next) {
      const target = next.offsetLeft - 16; // small padding
      container.scrollTo({ left: Math.min(target, container.scrollWidth - container.clientWidth), behavior: 'smooth' });
    } else {
      // fallback: page right by one viewport
      scrollHeader(container, container.clientWidth - 60);
    }
    setTimeout(() => updateScrollArrows(document), 150);
  }

  // Products header scroll arrows
  setTimeout(function() {
    const leftArrow = document.querySelector('.scroll-left');
    const rightArrow = document.querySelector('.scroll-right');
    const container = document.getElementById('products-header');
    
    if (leftArrow && container) {
      leftArrow.addEventListener('click', function(e) {
        e.preventDefault();
        container.scrollLeft -= 200;
      });
    }
    
    if (rightArrow && container) {
      rightArrow.addEventListener('click', function(e) {
        e.preventDefault();
        container.scrollLeft += 200;
      });
    }
  }, 1000);

  // Update arrow states on scroll (bind directly on the container)
  const productsHeader = document.querySelector('#products-header');
  if (productsHeader) {
    productsHeader.addEventListener('scroll', function() { updateScrollArrows(productsHeader.parentElement); }, { passive: true });
  }
  
  // Initial state
  setTimeout(function() { updateScrollArrows(document); }, 200);
})
